import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function Section7() {
  return (
    <>
      {/* Add strong CSS at the top level */}
      <style>
        {`
          body div#section7.section7,
          div#section7,
          #section7 {
            background-color: #f0e7da !important;
            background: #f0e7da !important;
          }
          
          /* Update text colors */
          #section7 .contact-header,
          #section7 .contact-info {
            color: #003594 !important;
          }
          
          /* Contact info styling */
          .contact-info-item {
            margin-bottom: 20px;
            padding: 15px;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.7);
            transition: all 0.3s ease;
          }
          
          .contact-info-item:hover {
            background-color: rgba(255, 255, 255, 0.9);
            transform: translateY(-5px);
            box-shadow: 0 5px 15px rgba(0, 53, 148, 0.1);
          }
          
          .contact-label {
            font-weight: bold;
            font-size: 1.1rem;
            margin-bottom: 5px;
            display: block;
          }
          
          .contact-value {
            font-size: 1.2rem;
            font-weight: 600;
          }
          
          .contact-value a {
            color: #003594;
            text-decoration: none;
            transition: color 0.3s ease;
          }
          
          .contact-value a:hover {
            color: #001f3f;
            text-decoration: underline;
          }
        `}
      </style>
      
      <div 
        id="section7" 
        className="section7 mt-scroll py-5 scroll-div" 
        style={{
          backgroundColor: '#f0e7da',
          background: '#f0e7da',
          minHeight: '300px' // Adjusted height for contact info
        }}
      >
        <Container className="mw-700">
          <h2 className="contact-header text-center primary mobile-mt-30" style={{ 
            color: '#003594',
            marginBottom: '40px',
            fontSize: '2rem',
            fontWeight: 'bold'
          }}>
            Contact Us
          </h2>
          
          <Row className="justify-content-center">
            <Col md={6} className="text-center mb-4 mb-md-0">
              <div className="contact-info-item">
                <span className="contact-label" style={{ color: '#003594' }}>
                  EMAIL
                </span>
                <div className="contact-value" style={{ color: '#003594' }}>
                  <a href="mailto:milabysmoky@kitopi.com">
                    milabysmoky@kitopi.com
                  </a>
                </div>
              </div>
            </Col>
            
            <Col md={6} className="text-center">
              <div className="contact-info-item">
                <span className="contact-label" style={{ color: '#003594' }}>
                  PHONE NUMBER
                </span>
                <div className="contact-value" style={{ color: '#003594' }}>
                  <a href="tel:+971507737884">
                    +971 50 773 7884
                  </a>
                </div>
              </div>
            </Col>
          </Row>
          
        </Container>
      </div>
    </>
  );
}

export default Section7;